import {IBannerAdObj, IWidgetBuilderComponent} from './types';
import {IWidgetResponse} from '../api/match-center';

export enum AllowedSportsForMCWidget {
  Football = 1,
  Handball = 2,
  Tennis = 3,
  IceHockey = 4,
  Basketball = 5,
  Baseball = 6,
  AmericanFootball = 7,
  Badminton = 18,
  Boxing = 19,
  Volleyball = 36,
  eSports = 67,
}

export function setBannerAdInfo(bannerRes: IBannerAdObj[], widget: IWidgetResponse | null) {

  if (widget && bannerRes && widget.builderComponentGroup) {
    //assign the ad banner data to banner components
    widget.builderComponentGroup.forEach(builderComponentGroup => {
      if (builderComponentGroup.widgetBuilderComponent) {
        builderComponentGroup.widgetBuilderComponent.forEach((widgetBuilderComponent) => {
          let banner = bannerRes.find(o => o.id === widgetBuilderComponent.id);
          if (banner) {
            widgetBuilderComponent.widgetBanner = banner.widgetBanner;
          }
        })
      }
    })
  }

  return widget;
}

export function setPositionOrder( widget: IWidgetResponse | null) {

  if (widget && widget.builderComponentGroup) {
    //change order of components to match their position value to prevent incorrect ordering
    const compare = ( a: IWidgetBuilderComponent, b: IWidgetBuilderComponent ) => {
      if ( a.position < b.position ){
        return -1;
      }
      if ( a.position > b.position ){
        return 1;
      }
      return 0;
    }

    widget.builderComponentGroup.forEach(builderComponentGroup => {
      if (builderComponentGroup.widgetBuilderComponent) {
        builderComponentGroup.widgetBuilderComponent.sort(compare);
      }
    })
  }

  return widget;
}
